import React from 'react';

export default function noAvailableItems(t) {
    return <h1 className="noAvailableItems">{t('noAvailableItems')}</h1>
}
